import axios from "axios";
import { ERP_URL } from "./config";

export const login_function = async (usr: string, pwd: any) => {
  return axios({
    method: "POST",
    headers: {
      "content-type": `application/json`,
      // "Access-Control-Allow-Origin": "*",
      "X-React-Login": "true"
    },
    url: `${ERP_URL}/api/method/login`,
    data: {
      usr,
      pwd,
    },
    withCredentials: true,
  })
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error:", err);
      return { message: err?.response?.data?.message, error: true };
    });
};

export const logout_function = async () => {
  return axios({
    method: "POST",
    headers: {
      "content-type": `application/json`,
      // "Access-Control-Allow-Origin": "*",
      "X-React-Login": "true"
    },
    url: `${ERP_URL}/api/method/logout`,
    withCredentials: true,
  })
    .then((res) => res.data)
    .catch((err) => err);
};

export const isAuthenticated = async () => {
  let logged_out = false;
  const user_resp = await axios({
    method: "GET",
    headers: {
      "content-type": `application/json`,
      // "Access-Control-Allow-Origin": "*",
      "X-React-Login": "true"
    },
    url: `${ERP_URL}/api/method/frappe.auth.get_logged_user`,
    // url: `${ERP_URL}/api/method/stars_et.stars_et.whitelist.get_logged_user`,
    withCredentials: true,
  })
    .then((res) => {
      return axios({
        method: "GET",
        headers: {
          "content-type": `application/json`,
          // "Access-Control-Allow-Origin": "*",
        },
        url: `${ERP_URL}/api/resource/User/${res.data.message}`,
        withCredentials: true,
      }).then((res) => res.data);
    })
    .catch((err) => {
      logged_out = true;
    });

  if (logged_out) {
    return null;
  }
  return (
    user_resp.data && {
      name: user_resp.data.name,
      email: user_resp.data.email,
      full_name: user_resp.data.full_name,
      username: user_resp.data.username,
      user_type: user_resp.data.user_type,
    }
  );
};
